/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ExecuteRecommendationRespModel {
    getFixupPrototypeFunction() { return ExecuteRecommendationRespModel.fixupPrototype; }

    static newInstance(model: Partial<ExecuteRecommendationRespModel>): ExecuteRecommendationRespModel {
        let obj = Object.assign(new ExecuteRecommendationRespModel(), model);
        ExecuteRecommendationRespModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ExecuteRecommendationRespModel>): ExecuteRecommendationRespModel {
        if (!model) return null;
        return ExecuteRecommendationRespModel.newInstance(<ExecuteRecommendationRespModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ExecuteRecommendationRespModel) {
        if (!obj) return;

        models.ExecuteRecommendationRespModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ExecuteRecommendationRespModel): boolean {
        Object.setPrototypeOf(obj, ExecuteRecommendationRespModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Status of that HTTP call
     */
    status: string;

    /**
     * Message of HTTP call
     */
    message: string;

    /**
     * response data
     */
    data: any;

}
